import  { RequestedShipment } from '../DHLModels/RequestedShipment';

export class ShipmentRequest {
    RequestedShipment: RequestedShipment ; 
}
 